import React from "react";

export interface IUserIconProps {
  size: number;
  color: string;
}
export default function PlusIcon({ size, color }: IUserIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 3C11.5 2.73478 11.3946 2.48043 11.2071 2.29289C11.0196 2.10536 10.7652 2 10.5 2C10.2348 2 9.98043 2.10536 9.79289 2.29289C9.60536 2.48043 9.5 2.73478 9.5 3V10H2.5C2.23478 10 1.98043 10.1054 1.79289 10.2929C1.60536 10.4804 1.5 10.7348 1.5 11C1.5 11.2652 1.60536 11.5196 1.79289 11.7071C1.98043 11.8946 2.23478 12 2.5 12H9.5V19C9.5 19.2652 9.60536 19.5196 9.79289 19.7071C9.98043 19.8946 10.2348 20 10.5 20C10.7652 20 11.0196 19.8946 11.2071 19.7071C11.3946 19.5196 11.5 19.2652 11.5 19V12H18.5C18.7652 12 19.0196 11.8946 19.2071 11.7071C19.3946 11.5196 19.5 11.2652 19.5 11C19.5 10.7348 19.3946 10.4804 19.2071 10.2929C19.0196 10.1054 18.7652 10 18.5 10H11.5V3Z"
        fill={color}
      />
    </svg>
  );
}
